import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementEmailTemplate.DeleteAttachment.IRequest;
type Response = Api.Core.StatementEmailTemplate.DeleteAttachment.IResponse;
type Headers = Api.Core.StatementEmailTemplate.DeleteAttachment.IHeaders;
const apiStatementEmailTemplateDeleteAttachmentPath =
  '/api/Management/StatementEmailTemplate/:id/DeleteAttachment/:fileId';
export default async function statementEmailTemplateDeleteAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementEmailTemplateDeleteAttachmentPath, { id, fileId: request.fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
